module.exports = __webpack_public_path__ + "img/gril.60b5ca6d.png";